import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ItemContainer } from '../interfaces/item-container';
import { CNConsultationType } from '../models/cnconsultation';
import { CNItem } from '../models/cnitem';
import { PatientService } from './patient.service';

@Injectable({
  providedIn: 'root'
})
export class UserOpenItemsService {

  public itemsSubject: BehaviorSubject<(CNItem & ItemContainer)[]> = new BehaviorSubject([]);
  public itemTypeEvent = new EventEmitter<[CNItem, CNConsultationType]>();
  public itemModifiedEvent = new EventEmitter<CNItem>();

  private openItems: (CNItem & ItemContainer)[] = [];
  private selectedSubs: Subscription;
  private interval;

  constructor(private patient: PatientService) {
    this.selectedSubs = this.patient.patientSelectedEvent.subscribe(() => {
      // clean openItems
      this.openItems = [];
      this.itemsSubject.next(this.openItems);
    });
    this.interval = setInterval(() => {
      this.openItems.forEach(openItem => {
        if (openItem !== null && openItem.checkModified()) {
          this.itemModifiedEvent.emit(openItem);
        }
      });
    }, 500);
  }

  addItem(item: (CNItem & ItemContainer), focus = false): void {
    this.openItems.push(item);
    this.itemsSubject.next(this.openItems);
  }

  removeItem(item: (CNItem & ItemContainer)): void {
    this.openItems.splice(this.openItems.indexOf(item), 1);
    this.itemsSubject.next(this.openItems);
  }

  setItemType(item: (CNItem & ItemContainer), type: CNConsultationType): void {
    if (this.openItems.indexOf(item) !== -1) {
      this.itemTypeEvent.emit([item, type]);
    }
  }

  items(key: string): CNItem[] {
    return this.openItems.filter(item => item.key === key);
  }
}
